import React from 'react';

const MaterialIcon = ({ name, size = 20, className = '', ariaHidden = true }) => (
  <span
    className={`material-symbols-outlined ${className}`}
    style={{ fontSize: `${size}px` }}
    aria-hidden={ariaHidden}
  >
    {name}
  </span>
);

export default MaterialIcon;

